import React, { useState } from "react";
import { useStaticQuery, graphql } from "gatsby";

import GradientHero from "../components/gradientHero";
import Layout from "../components/layout";

const Contact = ({ pageContext }) => {
  const wpdata = useStaticQuery(graphql`
    {
      wp {
        page(id: "/contact-us", idType: URI) {
          contactUsPage {
            heroHeader
            heroContent
            formHeader
            formContent
            ciItems {
              header
              image {
                altText
                sourceUrl
              }
              content {
                target
                title
                url
              }
            }
            heroImage {
              altText
              sourceUrl
            }
            optionsItems {
              content
              heading
              image {
                altText
                sourceUrl
              }
            }
          }
        }
      }
    }
  `);
  const data = wpdata?.wp?.page?.contactUsPage || {};

  const [email, setEmail] = useState("");
  const [name, setName] = useState("");

  const [address, setAddress] = useState();
  const [phone, setPhone] = useState("");
  const [message, setMessage] = useState("");

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);

  const validate = () => {
    try {
      // Test if variables arent empty
      if (!email || !name || !address || !phone || !message) {
        throw Error("Please ensure all fields are entered.");
      }

      // Test Email
      const re =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (!re.test(String(email).toLowerCase())) {
        throw Error("Please enter a valid email address.");
      }

      const rePhone = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/;
      if (!rePhone.test(String(phone).toLowerCase())) {
        throw Error("Please enter a valid phone number.");
      }

      return true;
    } catch (error) {
      setError(error.message);
      return false;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Clear messsages
    setSuccess(false);
    setError("");

    if (loading) return;
    setLoading(true);

    if (validate()) {
      var formdata = new FormData(e.target);

      var requestOptions = {
        method: "POST",
        body: formdata,
      };
      try {
        const rawRes = await fetch(
          "/cors-proxy/https://airmc.gideonwislang.com/wp-content/themes/integral/custom-form-submit.php",
          requestOptions
        );

        const res = await rawRes.json();

        if (res?.response === "success") {
          setSuccess(true);
        } else {
          throw Error();
        }
      } catch (error) {
        setError("Something went wrong please try again.");
      }
    }
    setLoading(false);
  };

  return (
    <Layout pageContext={pageContext}>
      <GradientHero image={data?.heroImage?.sourceUrl}>
        <h5>{data?.heroHeader}</h5>
        <p>{data?.heroContent}</p>
      </GradientHero>

      <div className="text-center max-w-5xl mt-24 mb-28 mx-5 md:mx-20 lg:mx-auto">
        <h5 className="text-black mb-10 text-3xl">{data?.formHeader}</h5>
        <p className="text-xl leading-8 mb-7">{data?.formContent}</p>
        {!success ? (
          <form className="max-w-xl text-left mx-auto" onSubmit={handleSubmit}>
            <div className="mb-4">
              <label className="text-xl" htmlFor="username">
                Name*
              </label>
              <input
                className="border border-black w-full py-2 px-3 focus:outline-none focus:shadow-outline"
                name="name"
                type="text"
                value={name}
                onChange={(v) => {
                  setName(v.target.value);
                }}
              />
            </div>
            <div className="mb-4">
              <label className="text-xl" htmlFor="email">
                Email*
              </label>
              <input
                className="border border-black w-full py-2 px-3 focus:outline-none focus:shadow-outline"
                name="email"
                type="text"
                value={email}
                onChange={(v) => {
                  setEmail(v.target.value);
                }}
              />
            </div>

            <div className="mb-4">
              <label className="text-xl" htmlFor="phone">
                Phone*
              </label>
              <input
                className="border border-black w-full py-2 px-3 focus:outline-none focus:shadow-outline"
                type="text"
                name="phone"
                value={phone}
                onChange={(v) => {
                  setPhone(v.target.value);
                }}
              />
            </div>

            <div className="mb-4">
              <label className="text-xl" htmlFor="address">
                Address
              </label>
              <input
                className="border border-black w-full py-2 px-3 focus:outline-none focus:shadow-outline"
                name="address"
                value={address}
                onChange={(v) => {
                  setAddress(v.target.value);
                }}
                type="text"
              />
            </div>

            <div className="mb-4">
              <label className="text-xl" htmlFor="message">
                Message
              </label>
              <textarea
                name="message"
                className="border border-black w-full py-2 px-3 focus:outline-none focus:shadow-outline h-36"
                value={message}
                onChange={(v) => {
                  setMessage(v.target.value);
                }}
                type="text"
              >
                {message}
              </textarea>
            </div>
            <input
              className="bg-tan font-anton text-3xl px-20 py-2 uppercase cursor-pointer border-none"
              type="submit"
              value={loading ? "Loading..." : "Submit"}
            />
            {!!error && <p className="text-red text-center mt-4">{error}</p>}
          </form>
        ) : (
          <p className="text-green font-400 font-16 text-center mb-8">
            Success! We'll get intouch with you shortly.
          </p>
        )}
      </div>

      <div className="bg-black py-16 border-b-2 border-tan">
        <div className="flex flex-wrap mx-auto text-white text-center max-w-7xl gap-y-10">
          {data?.ciItems?.map((v, i) => (
            <div key={i} className="my-4 px-4 w-1/2 w-full lg:w-1/3 xl:w-1/3">
              <img
                src={v?.image?.sourceUrl}
                className="mx-auto"
                style={{
                  maxWidth: "70px",
                  width: "auto",
                  maxHeight: "64px",
                  height: "auto",
                }}
              />
              <p className="text-lg font-bold leading-7 mt-4">{v?.header}</p>
              <a
                style={{ maxWidth: "200px" }}
                className="text-tan mx-auto inline-flex"
                href={v?.content?.url}
                target={v?.content?.target}
              >
                {v?.content?.title}
              </a>
            </div>
          ))}
        </div>
      </div>

      <div className="bg-black py-20">
        <div className="flex flex-wrap mx-auto w-full md:w-4/5 lg:w-3/4 xl:w-11/12 2xl:w-4/5 overflow-hidden text-white text-center max-w-7xl">
          {data?.optionsItems?.map((v, i) => (
            <div
              key={i}
              className="my-4 px-4 w-1/2 overflow-hidden w-full md:w-1/2 lg:w-1/2 xl:w-1/4"
            >
              <img
                className="mx-auto mb-4"
                style={{
                  maxWidth: "75px",
                  width: "auto",
                  maxHeight: "75px",
                  height: "auto",
                }}
                src={v?.image?.sourceUrl}
                alt={v?.image?.altText}
              ></img>
              <h5 className="text-center text-3xl">{v?.heading}</h5>
              <p className="text-xl leading-7">{v?.content}</p>
            </div>
          ))}
        </div>
      </div>
    </Layout>
  );
};

export default Contact;
